import { Box, Button, Flex, Text } from '@grupoboticario/flora-react'
import { CrossIcon } from '@grupoboticario/flora-react-icons'

import { ReactNode } from 'react'
import { isEmptyString } from 'src/helpers'

import {
  ModalTutorialDivisorContent,
  ModalTutorialFooter,
  ModalTutorialHeader,
  ModalTutorialHeaderButtonText,
  ModalTutorialWrapper,
  Image,
} from './ModalTutorial.style'
import { ModalTutorialNavigation, ModalTutorialNavigationProps } from './ModalTutorialNavigation'

export interface ModalTutorialProps extends ModalTutorialNavigationProps {
  onFinish?: () => void
}

const textDictionary: Array<{ text: string; image?: string; siblingNode?: ReactNode }> = [
  {
    text: 'Arraste para o lado para navegar entre as páginas',
    image: process.env.REACT_APP_IMAGE_TUTORIAL_STEP_0,
  },
  {
    text: 'Faça movimento de "pinça" com os dedos para dar zoom nas páginas.',
    image: process.env.REACT_APP_IMAGE_TUTORIAL_STEP_1,
  },
]

const hasShadows = textDictionary.every((tutorialStep) => !isEmptyString(tutorialStep.image || ''))

export const ModalTutorial = ({
  onPrev,
  onNext,
  onSkip,
  onFinish,
  currentStep = 0,
  totalSteps = 2,
}: ModalTutorialProps) => {
  const image = textDictionary[currentStep].image
  const description = textDictionary[currentStep].text
  const lastStep = totalSteps - 1
  const isLastStep = currentStep === lastStep

  const handlePrevious = () => onPrev?.()

  const handleNext = () => {
    if (isLastStep) {
      onFinish?.()
      return
    }

    onNext?.()
  }

  const handleSkip = () => {
    if (isLastStep) {
      onFinish?.()
      return
    }

    onSkip?.()
  }

  return (
    <ModalTutorialWrapper>
      <ModalTutorialHeader>
        <Button
          variant="unstyled"
          aria-label={isLastStep ? 'Fechar' : 'pular'}
          autotagging-flora="on"
          onClick={onSkip}
        >
          {isLastStep ? (
            <CrossIcon
              size={14}
              color="$nonInteractivePredominant"
            />
          ) : (
            <ModalTutorialHeaderButtonText size="exceptionsAuxiliarRegular">
              pular
            </ModalTutorialHeaderButtonText>
          )}
        </Button>
      </ModalTutorialHeader>

      <Flex justify="center">
        {typeof image === 'string' && !isEmptyString(image) && (
          <Image
            src={image}
            className={hasShadows ? 'tutorial-image-has-shadows' : undefined}
          />
        )}
      </Flex>

      <Box
        css={{
          padding: '$4',
        }}
      >
        <Text
          size="exceptionsAuxiliarRegular"
          color="$nonInteractivePredominant"
        >
          {description}
        </Text>
      </Box>

      <ModalTutorialDivisorContent />

      <ModalTutorialFooter>
        <ModalTutorialNavigation
          currentStep={currentStep}
          totalSteps={totalSteps}
          onPrev={handlePrevious}
          onNext={handleNext}
          onSkip={handleSkip}
        />
      </ModalTutorialFooter>
    </ModalTutorialWrapper>
  )
}
